import React from 'react';
import TextEditor from '../TextEditor/TextEditor';
import {Colors} from '../../../styles/Colors';
import {normalizeText} from '../../../services/Helpers';

const RichTextQuestion = ({value, onChange, error, disabled}) => {
    if (disabled) return <div className={'documentation-rich-text-answer'} dangerouslySetInnerHTML={{__html: value ?? ''}}/>;

    return (
        <div style={{height: '300px', borderRadius: '4px', outline: error ? `1px solid ${Colors.error}` : 'none'}}>
            <TextEditor hideTable disableAutoFocus value={value ?? ''} onChange={(html) => onChange(normalizeText(html))}/>
        </div>
    );
};

export default RichTextQuestion;
